import { HistoryRouterProps, unstable_HistoryRouter as ReactRouter } from "react-router-dom";

import { history } from "./history";

export const HistoryRouter: React.FC<Omit<HistoryRouterProps, "history">> = (props) => (
  <ReactRouter history={history} {...props} />
);
